import {
  PublicClientApplication,
  type IPublicClientApplication,
} from "@azure/msal-browser";

import { environment } from "../../../environments/environment";

/**
 * MSAL instance for the Davaco employee door on the apex host.
 * Public client, no secret — the same tenant the Creator and Service Provider
 * apps use.
 */
export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: {
      clientId: environment.msalConfig.auth.clientId,
      authority: environment.msalConfig.auth.authority,
      redirectUri: window.location.origin,
      postLogoutRedirectUri: window.location.origin,
    },
    cache: {
      cacheLocation: "localStorage",
    },
  });
}
